import dns from './dns'

export default {
  ...dns,
}
